import styled from 'styled-components'

import { COLORS } from '@/constants'

export const Popover = styled.div`
  background: ${COLORS.backgroundLight};
  box-shadow: 0 4px 16px rgba(4, 22, 20, 0.08);
  position: absolute;
  z-index: 1060;
  min-width: 250px;
  top: 100%;
  border-radius: 5px;
  border: 1px solid #dfe1e0;
  left: 0;
  white-space: normal;
`

export const Body = styled.div`
  display: flex;
  height: auto;
  flex-direction: column;
`

export const BottomPart = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  padding: 8px;
  border-top: 1px solid #dfe1e0;
`

export const MainPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  padding: 8px;
`

export const TopPart = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  padding: 8px;
  border-bottom: 1px solid #dfe1e0;
`
